import {SHOW_POPUP_WITH_SELECTBOX, HIDE_POPUP_WITH_SELECTBOX} from '@/store/mutation-types'

const state = {
	popupWithSelectbox: null
}

const getters = {
	hasPopupWithSelectbox: state => state.popupWithSelectbox !== null,
	getPopupWithSelectboxMessage: state => state.popupWithSelectbox.message,
	getPopupWithSelectboxSubmitButtonText: state => state.popupWithSelectbox.buttonText,
	getPopupWithSelectboxOptions: state => state.popupWithSelectbox.options,
	getPopupWithSelectboxData: state => state.popupWithSelectbox.data,
	getPopupWithSelectboxAction: state => state.popupWithSelectbox.action,
}

const actions = {
	[SHOW_POPUP_WITH_SELECTBOX]: ({commit, dispatch}, data) => {
		return new Promise((resolve, reject) => {
			commit(SHOW_POPUP_WITH_SELECTBOX, data);
			resolve();
		})
	},
	[HIDE_POPUP_WITH_SELECTBOX]: ({commit, dispatch}) => {
		return new Promise((resolve, reject) => {
			commit(HIDE_POPUP_WITH_SELECTBOX);
			resolve();
		})
	}
}

const mutations = {
	[SHOW_POPUP_WITH_SELECTBOX]: (state, data) => {
		state.popupWithSelectbox = data;
	},
	[HIDE_POPUP_WITH_SELECTBOX]: (state) => {
		state.popupWithSelectbox = null;
	}
}

export default {
	state,
	getters,
	actions,
	mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/popupWithSelectbox.js